import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PortabilityKeysPageRoutingModule } from './portability-keys-routing.module';

import { UiCHeaderPixModule } from '@wlp/ui-c-header-pix';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCPixPortabilityKeyPixModule } from '@wlp/ui-c-pix-portability-key-pix';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptService } from 'src/app/core/intercept/intercept.service';
import { PortabilityPage } from './portability/portability.page';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BrMaskerModule } from 'br-mask';
import { CodeValidationPage } from './code-validation/code-validation.page';
import { UiCSendCodeAccountActivationModule } from '@wlp/ui-c-send-code-account-activation';
import { ShowcasePage } from './showcase/showcase.page';
import { UiBsPixModule } from '@wlp/ui-bs-pix';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PortabilityKeysPageRoutingModule,
    UiCHeaderPixModule,
    UiBsTranslateModule,
    UiCButtonModule,
    UiCPixPortabilityKeyPixModule,
    AngularSvgIconModule.forRoot(),
    BrMaskerModule,
    UiCSendCodeAccountActivationModule,
    UiBsPixModule
  ],
  declarations: [
    PortabilityPage,
    CodeValidationPage,
    ShowcasePage
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ]
})
export class PortabilityKeysPageModule { }
